import {
	BaseError,
} from './BaseError';

export class LoadingConfError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
